/**文献标记列表 */
<template>
  <div class="annotation-list">
    <div class="list-header">
      <div class="left">
        <el-checkbox
          v-model="checkAll"
          :indeterminate="isIndeterminate"
          @change="handleCheckAllChange"
          class="checkbox-all"
        ></el-checkbox>
        <div class="theme-search">
          <span class="label">文献主题:</span>
          <SearchThemeSelector
            v-model:value="searchTheme"
            @change="handleChangeTheme"
          />
        </div>
        <div class="keywords-search">
          <el-input
            v-model="keywords"
            placeholder="请输入关键词"
            :suffix-icon="Search"
            @keyup.enter="handleSearchAnnotations"
          >
            <template #prepend>
              <el-select v-model="keywordsType" style="width: 110px">
                <el-option label="文献标题" value="literatureTitle" />
                <el-option label="文献作者" value="literatureAuthor" />
                <el-option label="标注原文" value="citation" />
                <el-option label="标注注释" value="comment" />
              </el-select>
            </template>
          </el-input>
        </div>
      </div>
      <div class="right">
        <DropdownSelector
          v-model:value="orderType"
          :data="orderTypeList"
          dropdownWidth="140"
          @change="handleChangeOrderType"
        >
          <template #prefix>
            <i class="iconfont icon-descending" />
          </template>
        </DropdownSelector>
      </div>
    </div>
    <div
      v-loading="listLoading"
      class="list-content"
      :class="listData.length > 0 ? '' : 'loading-bg'"
    >
      <div class="content" v-if="listData.length > 0">
        <div class="list-box">
          <div class="list-item" v-for="item in listData" :key="item.uid">
            <el-checkbox
              class="checkbox"
              v-model="item.isChecked"
              @change="updateSelectedList"
            />
            <div class="list-card">
              <AnnotationCard
                :annotationItem="item"
                @refresh="getData"
                @cancel-edit="cancelCommentEdit"
                @clear-annotation="clearAnnotation"
                @import-to-note="importToNote"
                :isEditable="isEditable(item.permission)"
                :isShared="isShared(item.shareStatus)"
              >
                <template #header>
                  <div class="card-header">
                    <div class="literature-info">
                      <span class="label">
                        <i class="iconfont icon-xiezuopingtai_wenxian" />
                      </span>
                      <span class="info">
                        <span class="title" @click="goRead(item.literatureUid)">
                          {{ item.literatureTitle }}
                        </span>
                        <el-divider
                          direction="vertical"
                          v-show="item.literatureAuthor"
                          style="margin: 0 15px"
                        />
                        <span class="authors">
                          {{ item.literatureAuthor }}
                        </span>
                        <el-divider
                          direction="vertical"
                          v-show="item.publicationYear"
                          style="margin: 0 15px"
                        />
                        <span class="year">
                          {{ item.publicationYear }}
                        </span>
                      </span>
                    </div>
                    <div class="annotation-info card-info">
                      <CreatorTag
                        class="annotation-creator creator"
                        :name="item.userName"
                        v-if="isShared(item.shareStatus)"
                        :style="
                          !isEditable(item.permission) ? 'right:10px' : ''
                        "
                      />
                      <div
                        class="annotation-time time"
                        :style="!isEditable(item.permission) ? 'right:0' : ''"
                      >
                        {{ item.createTime }}
                      </div>
                    </div>
                  </div>
                </template>
              </AnnotationCard>
            </div>
          </div>
        </div>
        <div class="pagination-box">
          <el-pagination
            v-model:current-page="paginationState.pageNum"
            v-model:page-size="paginationState.pageSize"
            small
            layout="total, prev, pager, next, sizes"
            :total="paginationState.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40]"
          />
        </div>
      </div>
      <div class="empty" v-if="!listLoading && listData.length == 0">
        <el-empty
          :image-size="220"
          :image="require('@/assets/imgs/literature/empty.png')"
        >
          <template #description>
            <span style="color: #848486">暂无标注</span>
          </template>
        </el-empty>
      </div>
    </div>
    <DrawerImportToNote ref="drawerImportToNoteRef" />
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  defineEmits,
  watch,
  defineProps,
  defineExpose,
  onMounted,
  computed,
  nextTick,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { httpPost } from "@/api/httpService";
import { bus } from "@/utils/mitt.js";
import { ElMessage } from "element-plus";
import { Search } from "@element-plus/icons-vue";
import AnnotationCard from "@/components/literature/AnnotationCard.vue";
import { confirmBox } from "@/utils/messageBox.js";
import DrawerImportToNote from "@/components/literature/DrawerImportToNote.vue";
import DropdownSelector from "@/components/selector/DropdownSelector.vue";
import SearchThemeSelector from "@/components/literature/SearchThemeSelector.vue";
import CreatorTag from "@/components/user/CreatorTag.vue";
import {
  SHARE_THEME_PERMISSION,
  SHARE_THEME_STATUS,
} from "@/constant/share_theme.js";

const router = useRouter();

const emits = defineEmits(["select-change", "update-filter", "refresh"]);
const props = defineProps({
  filterData: {
    type: Object,
    default: () => {},
  },
});

//是否可编辑的/是否已共享的
const isEditable = computed(() => {
  return (sharePermission) => {
    return sharePermission != SHARE_THEME_PERMISSION.VIEW;
  };
});
const isShared = computed(() => {
  return (shareStatus) => {
    return shareStatus != SHARE_THEME_STATUS.UNSHARED;
  };
});

//#region 多选相关
const selectItemList = ref([]);
const updateSelectedList = () => {
  selectItemList.value = listData.value.filter((item) => item.isChecked);
  emits("select-change", selectItemList.value);
  if (
    selectItemList.value.length == listData.value.length &&
    selectItemList.value.length != 0
  ) {
    checkAll.value = true;
  } else {
    checkAll.value = false;
  }
};
const checkAll = ref(false);
const handleCheckAllChange = (val) => {
  listData.value.forEach((item) => {
    item.isChecked = val;
  });
  updateSelectedList();
};
const isIndeterminate = computed(() => {
  return (
    selectItemList.value.length != listData.value.length &&
    selectItemList.value.length != 0
  );
});
const clearSelection = () => {
  listData.value.forEach((item) => {
    item.isChecked = false;
  });
  updateSelectedList();
};
//#endregion 多选相关

//#region 树形主题相关
const searchTheme = ref([]);
const searchNoSubTheme = ref([]);
const handleChangeTheme = (params) => {
  searchTheme.value = params.searchTheme;
  searchNoSubTheme.value = params.searchNoSubTheme;
  handleSearchAnnotations();
};
//#endregion 树形主题相关

//#region 筛选相关
const orderType = ref(2);
const orderTypeList = ref([
  { label: "按标注时间升序", value: 1 },
  { label: "按标注时间降序", value: 2 },
  { label: "按发表年份升序", value: 3 },
  { label: "按发表年份降序", value: 4 },
]);
const handleChangeOrderType = (value) => {
  getData();
};
//关键词
const keywords = ref("");
const keywordsType = ref("literatureTitle");
const literatureTitle = ref(null);
const literatureAuthor = ref(null);
const citation = ref(null);
const comment = ref(null);
const handleSearchAnnotations = () => {
  updateSearch();
  getData();
};
const updateSearch = () => {
  literatureTitle.value = null;
  literatureAuthor.value = null;
  citation.value = null;
  comment.value = null;
  if (keywords.value.trim()) {
    switch (keywordsType.value) {
      case "literatureTitle":
        literatureTitle.value = keywords.value;
        break;
      case "literatureAuthor":
        literatureAuthor.value = keywords.value;
        break;
      case "citation":
        citation.value = keywords.value;
        break;
      case "comment":
        comment.value = keywords.value;
        break;
      default:
        break;
    }
  }
  emits("update-filter", {
    topicUidList:
      searchTheme.value.filter((item) => !item.startsWith("noSubUid_"))
        .length == 0
        ? null
        : searchTheme.value.filter((item) => !item.startsWith("noSubUid_")),
    unChildUidList:
      searchNoSubTheme.value.length == 0
        ? null
        : searchNoSubTheme.value.map((item) => item.split("noSubUid_")[1]),
    literatureTitle: literatureTitle.value,
    literatureAuthor: literatureAuthor.value,
    citation: citation.value,
    comment: comment.value,
  });
};
//#endregion 筛选相关

//获取表格数据
const listData = ref([]);
const listLoading = ref(false);
const getData = async () => {
  listLoading.value = true;
  let params = {
    pageNum: paginationState.pageNum,
    pageSize: paginationState.pageSize,
    topicUidList:
      searchTheme.value.filter((item) => !item.startsWith("noSubUid_"))
        .length == 0
        ? null
        : searchTheme.value.filter((item) => !item.startsWith("noSubUid_")),
    unChildUidList:
      searchNoSubTheme.value.length == 0
        ? null
        : searchNoSubTheme.value.map((item) => item.split("noSubUid_")[1]),
    literatureTitle: literatureTitle.value,
    literatureAuthor: literatureAuthor.value,
    citation: citation.value,
    comment: comment.value,
    markType: filterDataTemp.value.markType || null,
    markColor: filterDataTemp.value.markColor || null,
    markBeginTime: filterDataTemp.value.markBeginTime || null,
    markEndTime: filterDataTemp.value.markEndTime || null,
    tagList: filterDataTemp.value.markTag || null,
    orderType: orderType.value,
  };
  let res = await httpPost("/literatureMark/v1/searchUserMark", params);
  if (res.code == 0) {
    listData.value = res.data.data;
    paginationState.total = res.data.total;
  }
  clearSelection();
  listLoading.value = false;
};

//监听筛选条件
const filterDataTemp = ref({});
watch(
  () => props.filterData,
  (newVal, oldVal) => {
    if (newVal) {
      filterDataTemp.value = JSON.parse(JSON.stringify(newVal));
      getData();
    }
  },
  { immediate: true, deep: true }
);

//前往AI阅读页面
const goRead = (id) => {
  const resolved = router.resolve({
    name: "LiteratureDetail",
    params: {
      literatureUid: id,
      page: "detail",
    },
  });
  const url = resolved.href;
  window.open(url, "_blank");
};

//将其他正在编辑的取消编辑
const cancelCommentEdit = () => {
  listData.value.forEach((item) => {
    item.commentList?.forEach((comment) => {
      comment.ifEditing = false;
    });
  });
};
//删除标注
const clearAnnotation = (literatureMarkUid) => {
  confirmBox(`确定删除该原文及注释吗？
`).then(async () => {
    let params = {
      literatureMarkUidList: [literatureMarkUid],
    };
    let res = await httpPost("/literatureMark/v1/batchDeleteMark", params);
    if (res.code == 0) {
      ElMessage.success("删除成功");
      getData();
      emits("refresh");
    }
  });
};

//导入到笔记
const drawerImportToNoteRef = ref(null);
const importToNote = (content) => {
  drawerImportToNoteRef.value.openDWR(content);
};

// 分页信息
const paginationState = reactive({
  pageNum: 1,
  pageSize: 10,
  total: 0,
});
// 改变页面容纳数据量
const handleSizeChange = (val) => {
  paginationState.pageSize = val;
  getData();
};
// 切换当前页码
const handleCurrentChange = (val) => {
  paginationState.pageNum = val;
  getData();
};

onMounted(async () => {
  await getData();
});

defineExpose({ getData });
</script>

<style lang="scss" scoped>
@import "@/assets/styles/module/module-index.scss";
</style>
